import {Component, Input} from '@angular/core';
import { GoogleTagManagerService } from 'src/app/core/analytics/google-tag-manager.service';
import { FeatureToggleService } from 'src/app/core/toggle/feature-toggle.service';
import { ProductCard } from '../../models/product-card.model';
import { ProductGridEvent } from '../../models/product-grid-event.model';
import {ProductUrlService} from '../../services/product/product-url.service';

@Component({
  selector: 'lps-link-product',
  templateUrl: './link-product.component.html',
  styleUrls: ['./link-product.component.scss']
})
export class LinkProductComponent {

  @Input() productCard: ProductCard;
  @Input() target: string;
  @Input() pathname: string;
  @Input() gridName: string;
  @Input() nickname: string;

  constructor(
    private readonly productUrlService: ProductUrlService,
    private readonly featureToggleService: FeatureToggleService,
    private readonly googleTagManagerService: GoogleTagManagerService
  ) {
  }

  goToProduct(sku: string) {
    if (this.nickname && this.pathname) {
      const path = this.productUrlService.mapProductUrl(this.productCard, '');
      window.open(`${this.pathname}${path}?Corretor=${this.nickname}`, this.target);
    } else if (this.pathname) {
      window.open(`${window.location.origin + this.pathname + sku}`, this.target);
    } else if (this.isToggleProductUrlActive) {
      const path = this.productUrlService.mapProductUrl(this.productCard, '');
      window.open(`${window.location.origin}${path}`, this.target);
    } else {
      window.open(`${window.location.origin}/imovel/${sku}`, this.target);
    }
  }

  get productUrl() {
    if (this.isToggleProductUrlActive) {
      return this.productUrlService.mapProductUrl(this.productCard, this.pathname);
    }
    return null;
  }

  get isToggleProductUrlActive() {
    return this.featureToggleService.isActive('toggle_product_url');
  }

  sendAnalyticsEvent($event) {
    $event.stopPropagation();
    if (this.featureToggleService.isActive('toggle_product_analytics')) {
      const analyticsEvent = ProductGridEvent.forClick(this.gridName, this.productCard.analytics);
      this.googleTagManagerService.pushTag(analyticsEvent);
    }
  }
}
